import { render, staticRenderFns } from "./CreateBroker.vue?vue&type=template&id=b2932642&scoped=true&"
import script from "./CreateBroker.vue?vue&type=script&lang=js&"
export * from "./CreateBroker.vue?vue&type=script&lang=js&"
import style0 from "./CreateBroker.vue?vue&type=style&index=0&id=b2932642&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2932642",
  null
  
)

export default component.exports